import { render, staticRenderFns } from "./TiltakPage.vue?vue&type=template&id=51dcfc5b"
import script from "./TiltakPage.vue?vue&type=script&lang=js"
export * from "./TiltakPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports